import { TUseSearchParams } from '@/hooks/use-search-params.ts';
import { useEffect, useState } from 'react';
import { Checkbox } from '@/components/ui/checkbox.tsx';
import { Label } from '@/components/ui/label.tsx';
import { TFacet } from '@/types/models.ts';

export function FacetCheckboxes({
  facets,
  facetKey,
  useSearch,
}: {
  facets: TFacet[];
  facetKey: string;
  useSearch: TUseSearchParams;
}) {
  const [checkedItems, setCheckedItems] = useState(String(useSearch.get(facetKey)).split(','));
  const less = facets.slice(0, 8);
  const more = facets.slice(8, 20);
  more.forEach((item, i) => {
    if (checkedItems.includes(String(item.value)) && !less.find((f) => String(f.value) === String(item.value))) {
      less.unshift(item);
      more.splice(i, 1);
      const pop = less.pop();
      if (pop) {
        more.unshift(pop);
      }
    }
  });
  const handleCheckedChange = (facet: TFacet, checked: boolean | 'indeterminate') => {
    if (checked) {
      setCheckedItems((prevState) => [...prevState, String(facet.value)]);
      useSearch.addValue(facetKey, facet.value);
    } else {
      setCheckedItems((prevState) => prevState.filter((item) => item !== String(facet.value)));
      useSearch.removeValue(facetKey, facet.value);
    }
  };
  const isChecked = (value: string | number) => {
    return checkedItems.includes(String(value));
  };
  useEffect(() => {
    if (facetKey in useSearch.params) {
      setCheckedItems(String(useSearch.get(facetKey)).split(','));
    } else {
      setCheckedItems([]);
    }
  }, [useSearch.params]);
  return (
    <div data-facet={facetKey} className="flex flex-col gap-4">
      {less.map((facet) => (
        <div key={facet.value} className="flex items-center">
          <Checkbox
            id={`${facetKey}-checkbox-${facet.value}`}
            checked={isChecked(facet.value)}
            onCheckedChange={(checked) => handleCheckedChange(facet, checked)}
          />
          <Label htmlFor={`${facetKey}-checkbox-${facet.value}`} className="pl-2 cursor-pointer">
            {facet.name} ({facet.count})
          </Label>
        </div>
      ))}
      {more.length > 0 && (
        <details>
          <summary className="cursor-pointer text-sm text-blue-600">Show more</summary>
          <div className="mt-2 flex flex-col gap-4">
            {more.map((facet) => (
              <div key={facet.value} className="flex items-center">
                <Checkbox
                  id={`${facetKey}-checkbox-${facet.value}`}
                  checked={isChecked(facet.value)}
                  onCheckedChange={(checked) => handleCheckedChange(facet, checked)}
                />
                <Label htmlFor={`${facetKey}-checkbox-${facet.value}`} className="pl-2 cursor-pointer">
                  {facet.name} ({facet.count})
                </Label>
              </div>
            ))}
          </div>
        </details>
      )}
    </div>
  );
}
